module.exports = __webpack_public_path__ + "static/media/Sketch1.f7fdef8f.jpg";